// Anonyme, gerätegebundene Identität für Kontakt-Verbindungen. Kein Login -
// beim ersten Gebrauch erzeugt die App eine zufällige ID plus ein Geheimnis,
// genau wie bei Fahrer- und Mitfahrer-Tokens, und hält beides lokal.
// Konsequenz: App-Daten löschen oder das Gerät wechseln bedeutet, Kontakte
// neu zu verbinden.

import { randomId, randomToken } from './id';

const KEY = 'r2f.device';
const NAME_KEY = 'r2f.device.name';

export interface DeviceIdentity {
  id: string;
  token: string;
}

function loadOrCreateIdentity(): DeviceIdentity {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (typeof parsed?.id === 'string' && typeof parsed?.token === 'string') return parsed;
    }
  } catch {
    // Kaputter Eintrag - neu erzeugen.
  }

  const identity: DeviceIdentity = { id: randomId(), token: randomToken() };
  try {
    localStorage.setItem(KEY, JSON.stringify(identity));
  } catch {
    // Privater Modus o. Ä. - die Identität lebt dann nur für diese Sitzung.
  }
  return identity;
}

let cached: DeviceIdentity | null = null;

export function getDeviceIdentity(): DeviceIdentity {
  if (!cached) cached = loadOrCreateIdentity();
  return cached;
}

export function getDeviceName(): string {
  try {
    return localStorage.getItem(NAME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function setDeviceName(name: string): void {
  try {
    localStorage.setItem(NAME_KEY, name.trim().slice(0, 40));
  } catch {
    // egal
  }
}

/** Das Objekt, das jeder gerätegebundene API-Aufruf mitschickt. */
export function deviceParams(): { deviceId: string; token: string; name?: string } {
  const identity = getDeviceIdentity();
  const name = getDeviceName();
  return { deviceId: identity.id, token: identity.token, ...(name ? { name } : {}) };
}
